<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.valOperator"
            :props="formData.props3" :options="render.cascade_options_direct" />
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.exportAllExcel()" class="search4" type="info">{{ $t('g.export') }}</el-button>
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
        <el-button @click="func.showAddDataDialog" type="primary" class="btn-add">{{ $t('g.added') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table @row-click.self="func.showDetails" :data="formData.tableData" style="width: 100%">
        <el-table-column prop="Id" label="ID" width="60">
        </el-table-column>
        <el-table-column prop="Name" label="场站名称" width="140">
        </el-table-column>
        <el-table-column prop="AgentCode" :label="$t('g.agent_code')" v-if="!isOperator()">
        </el-table-column>
        <el-table-column prop="name_path" :label="$t('g.operator_ownership')" :show-overflow-tooltip='true'>
        </el-table-column>
        <!-- <el-table-column prop="ProvinceAndCityText" label="省市区" width="180">
          </el-table-column> -->
        <el-table-column prop="Address" :label="$t('siteManager.detailed_address')">
        </el-table-column>
        <el-table-column prop="CreateAtStr" min-width="180" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column width="170" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.edit(scope.row)" class="btn-edit" type="primary">{{
              $t('g.edit')
            }}</el-button>
            <el-button @click="func.delete(scope.row.Id)" class="btn-delete" type="primary"
              style="margin-left: 10px;">{{ $t('g.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('g.edit')" v-model="formData.dialogVisible" width="90%" style="padding: 20px 30px;"
      align-center :before-close="func.closeDetailDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- <div class="reminder">*提示：新建场站保存后请在场站的编辑里添加人员配置</div> -->
      <el-tabs v-model="formData.activeName" type="card" class="tabs">
        <el-tab-pane label="场站基本信息" name="first">
          <el-form label-width="100px" :model="formData.curData" style="margin-top: 45px;">
            <div class="box_flex">
              <el-form-item label="场站名称" style="width: 50%;" :required="true">
                <el-input v-model="formData.curData.Name"></el-input>
              </el-form-item>
            </div>
            <div class="box_flex">
              <el-form-item :label="$t('rights.agent')" v-if="formData.is_opt" style="width: 50%;">
                <el-cascader style="width: 100%;" :clearable="true" v-model="formData.curData.AgentCode"
                  :props="formData.props2" :options="render.cascade_options_direct" />
              </el-form-item>
              <el-form-item :label="$t('g.operator')" style="width: 50%;" :required="true">
                <el-cascader style="width: 100%;" :clearable="true" v-model="formData.curData.CodePath"
                  :props="formData.props" :options="render.cascade_options_direct" />
              </el-form-item>
            </div>
            <div class="box_flex">
              <el-form-item :label="$t('siteManager.detailed_address')" style="width: 50%;" :required="true">
                <el-input v-model="formData.curData.Address"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="接警人配置" name="second" v-if="formData.form_type == 'edit'">
          <div class="personnel_btn"><el-button type="primary" @click="func.AddPersonnel">新增</el-button></div>
          <el-table :data="formData.tablePersonne" style="width: 100%">
            <el-table-column prop="Name" label="姓名" width="180" />
            <el-table-column prop="Phone" label="电话" width="180" />
            <el-table-column prop="Role" label="身份类型">
              <template #default="scope">
                <span v-if="scope.row.Role == 1">大经理</span>
                <span v-else-if="scope.row.Role == 2">城市负责人</span>
                <span v-else-if="scope.row.Role == 3">城市维修库管</span>
                <span v-else-if="scope.row.Role == 4">换电人员</span>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template #default="scope">
                <el-button @click="func.handleEdit(scope.row)">
                  编辑
                </el-button>
                <el-button type="danger" @click="func.personnelDelete(scope.row.Id)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next" @current-change="func.pageChange2"
            :page-size="formData.pageSize2" :current-page="formData.curPage2" :total="formData.total2"
            style="margin-top: 30px;">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="func.updateData()">{{ formData.saveText }}</el-button>
        </span>
      </template>
      <el-dialog v-model="formData.innerVisible" width="1200" :title="formData.personnelType == 'add' ? '新增' : '编辑'"
        append-to-body>
        <el-form label-width="140px" :model="formData.curData2" style="margin-top: 45px;">
          <div class="box_flex">
            <el-form-item label="姓名" style="width: 50%;" :required="true">
              <el-input v-model="formData.curData2.Name"></el-input>
            </el-form-item>
            <el-form-item label="电话" style="width: 50%;" :required="true">
              <el-input v-model="formData.curData2.Phone"></el-input>
            </el-form-item>
          </div>
          <div class="box_flex">
            <el-form-item label="身份类型" style="width: 50%;" :required="true">
              <el-select class="inp" v-model="formData.curData2.Role">
                <el-option label="大经理" :value="1">
                </el-option>
                <el-option label="城市负责人" :value="2">
                </el-option>
                <el-option label="城市维修库管" :value="3">
                </el-option>
                <el-option label="换电人员" :value="4">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <template #footer>
          <div class="dialog-footer">

            <el-button @click="formData.innerVisible = false">
              取消
            </el-button>
            <el-button type="primary" @click="func.personnelSave">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </el-dialog>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDetailVisible" width="80%" style="padding: 20px 30px;"
      align-center>
      <el-descriptions border>
        <el-descriptions-item :label="$t('device.site_name')">{{
          formData.curData.Name
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator')">{{
          formData.curData.CodePath
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('siteManager.detailed_address')">{{
          formData.curData.Address
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{
          formData.curData.CreateAtStr
        }}</el-descriptions-item>
      </el-descriptions>
      <el-table v-if="formData.tablePersonne.length != 0" :data="formData.tablePersonne"
        style="width: 100%;margin-top: 10px;" border>
        <el-table-column prop="Name" label="姓名" />
        <el-table-column prop="Phone" label="电话" />
        <el-table-column prop="Role" label="身份类型">
          <template #default="scope">
            <span v-if="scope.row.Role == 1">大经理</span>
            <span v-else-if="scope.row.Role == 2">城市负责人</span>
            <span v-else-if="scope.row.Role == 3">城市维修库管</span>
            <span v-else-if="scope.row.Role == 4">换电人员</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, onMounted, computed, watch } from 'vue'
import { operators, updateOperators, shortcuts, operatorList, cascade_options_direct } from '@/data/default'
import { toDay } from '@/common/func'
import city from '@/common/city.json'
import axios from "axios"
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import i18n from '@/data/i18n/index'
import { isOperator, isPath, isAdmin, user } from '@/data/token'
import cfg from '@/common/conf'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  name: 'stationManager',
  setup() {
    const t = i18n.global.t
    const tableData = []
    const render = {
      operators,
      parkingFee: [
        {
          label: t('siteManager.parking_fee'),
          value: 1
        },
        {
          label: t('siteManager.free_parking'),
          value: 2
        }, {
          label: t('siteManager.free_time'),
          value: 3
        },
        {
          label: t('siteManager.charging_free'),
          value: 4
        }
      ],
      chargingStation: [
        {
          label: t('siteManager.public_stations'),
          value: 1
        },
        {
          label: t('siteManager.commercial_stations'),
          value: 2
        }, {
          label: t('siteManager.residential_station'),
          value: 3
        },
        {
          label: t('siteManager.highway_station'),
          value: 4
        },
        {
          label: t('siteManager.smart_station'),
          value: 5
        }
      ],
      shortcuts,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      dialogVisible: false,
      dialogDetailVisible: false,
      dialogDisplayVisible: false,
      curPage: 1,
      pageSize: 10,
      total: 500,
      curPage2: 1,
      pageSize2: 10,
      total2: 1,
      valOperator: 0,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "CodePath",
        emitPath: false,
        checkStrictly: false
      },
      props2: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Code",
        emitPath: false,
        checkStrictly: true
      },
      props3: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "CodePath",
        emitPath: false,
        checkStrictly: true
      },
      IsStartWith: 1,
      is_opt: false,
      activeName: 'first',
      time_slot: [],
      timeInfo: [],
      form_type: 'add',
      fileList: [],
      uploadVisible: false,
      dialogImageUrl: '',
      dataImg: {
        Img0: '',
        Img1: '',
        Img2: ''
      },
      DevType: '',
      personnelType: 'add',
      tablePersonne: [],
      innerVisible: false,
      curData2: {},
      saveText: '下一步',
    })
    // watch(() => formData.curData.CodePath, () => {
    //   //let simplerWay = formData.curData.agentPath.slice(0, -1).split('/').pop(); 
    //   func.getDevType(formData.curData.CodePath)
    // })
    onMounted(() => {
      func.loadData()
      if (localStorage.getItem('user_info')) {
        formData.user_info = JSON.parse(localStorage.getItem('user_info'))
        if (formData.user_info.RoleId == 14 || formData.user_info.RoleId == 25 || formData.user_info.RoleId == 18) {
          formData.is_opt = true
        }
      }
    })
    const func = {
      async exportAllExcel() {
        let params = {
          GetAll: 1,
        }
        if (formData.valOperator) {
          params.CodePath = formData.valOperator
        }
        params.DevType = 4
        let loading = ''
        loading = ElLoading.service({
          lock: true,
          text: t('openSlotsLit.loading'),
          background: 'rgba(0, 0, 0, 0.7)',
        })
        let res = await axios.get(`/admin/pilesite/get`, {
          params
        })

        let excleData = [[
          'ID',
          '场站名称',
          '运营商归属',
          '详细地址',
          '创建时间',
          '姓名',
          '电话',
          '身份类型',
        ]];
        let wscols = [
          { wch: 10 },
          { wch: 20 },
          { wch: 30 },
          { wch: 30 },
          { wch: 14 },
          { wch: 12 },
          { wch: 14 },
          { wch: 18 },
        ];

        const merges = []
        let currentRow = 1 // 0 is header, data starts from row 1
        if (res && res.List) {
          for (let item of res.List) {
            const staffs = item.StaffInfo && item.StaffInfo.length ? item.StaffInfo : []
            const created = toDay(item.CreateAt)
            const rowCount = Math.max(1, staffs.length)
            if (rowCount > 1) {
              for (let col = 0; col <= 4; col++) {
                merges.push({ s: { r: currentRow, c: col }, e: { r: currentRow + rowCount - 1, c: col } })
              }
            }
            if (staffs.length > 0) {
              staffs.forEach((p, idx) => {
                const roleText = p.Role == 1 ? '大经理' : p.Role == 2 ? '城市负责人' : p.Role == 3 ? '城市维修库管' : p.Role == 4 ? '换电人员' : ''
                if (idx === 0) {
                  excleData.push([
                    item.Id || '',
                    item.Name || item.DeviceSiteName || '',
                    item.name_path || item.CodePath || '',
                    item.Address || '',
                    created || '',
                    p.Name || '',
                    p.Phone || '',
                    roleText,
                  ])
                } else {
                  excleData.push([
                    '', '', '', '', '',
                    p.Name || '',
                    p.Phone || '',
                    roleText,
                  ])
                }
              })
            } else {
              excleData.push([
                item.Id || '',
                item.Name || item.DeviceSiteName || '',
                item.name_path || item.CodePath || '',
                item.Address || '',
                created || '',
                '', '', '',
              ])
            }

            currentRow += rowCount
          }
        }

        const worksheet = XLSX.utils.aoa_to_sheet(excleData)
        worksheet["!cols"] = wscols
        if (merges.length > 0) worksheet["!merges"] = merges

        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
        loading.close()
        XLSX.writeFile(workbook, '场站及人员列表' + '.xlsx')
      },
      async closeDetailDialog(done) {
        console.log('关闭对话框')
        if (formData.form_type == 'edit') {
          let arr = []
          for (let i = 0; i < formData.tablePersonne.length; i++) {

            if (!arr.includes(formData.tablePersonne[i].Role)) {
              arr.push(formData.tablePersonne[i].Role)
            }
          }
          if (arr.length < 4) {
            ElMessage({
              type: 'error',
              message: '请配置四种不同类型的接警人员'
            })
            return
          } else {
            formData.dialogVisible = false
            if (typeof done === 'function') done()
          }
        } else {
          formData.dialogVisible = false
          if (typeof done === 'function') done()
        }
        // formData.dialogVisible = false
        // if (typeof done === 'function') done()
        // try{
        //   await ElMessageBox.confirm('有未保存的数据，确定要关闭吗？','提示',{
        //     confirmButtonText: '确认',
        //     cancelButtonText: '取消'
        //   })
        //   formData.dialogVisible = false
        //   if (typeof done === 'function') done()
        // }catch(e){
        //   // 取消：不执行 done，不关闭对话框
        // }
      },
      search() {
        console.log('formData', formData)
        func.loadData()
      },
      async showDetails(row, column) {
        if (column && column.label == t('g.operation')) {
          return;
        }
        formData.curData = row;
        func.personneGet()
        formData.dialogDetailVisible = true;
      },
      edit(row, column, e) {
        formData.curData = row
        delete formData.curData.DevId
        delete formData.curData.DevTypeStr
        formData.form_type = 'edit'
        formData.activeName = 'first'
        formData.saveText = '保存'
        //获取接警人员列表
        func.personneGet()
        // formData.curData.CodePath = row.CodePath
        // formData.curData.AgentCode = row.AgentCode
        formData.dialogVisible = true
      },
      async personneGet(page = 1) {
        formData.tablePersonne = []
        formData.curPage2 = page
        let params = {
          PileSiteId: formData.curData.Id,
          page
        }
        let res = await axios.get(`/admin/staff/get`, {
          params
        })
        formData.total2 = res.Total
        res.List.map((item) => {
          item.CreateAtStr = toDay(item.CreateAt)
        })
        formData.tablePersonne = res.List
        formData.PageSize2 = res.PageSize
        console.log('人员列表', res)

      },
      async handleEdit(data) {
        formData.personnelType = 'edit'
        console.log(data, '编辑人员信息')
        formData.curData2 = Object.assign({}, data)
        formData.innerVisible = true
        console.log('编辑人员')
      },
      async AddPersonnel() {
        console.log(formData.curData, '站点信息')
        formData.curData2 = {}
        formData.personnelType = 'add'
        formData.innerVisible = true
      },
      async personnelSave() {
        let res
        try {
          let params = Object.assign({}, formData.curData2)
          params.PileSiteId = formData.curData.Id
          // params.ProvinceAndCity = JSON.stringify(formData.curData.ProvinceAndCity)
          if (formData.personnelType == 'edit') {
            params.Id = formData.curData2.Id
            res = await axios.post('/admin/staff/edit', params)
          } else {
            if (params.Name == '' || !params.Name || params.Phone == '' || !params.Phone) {
              ElMessage({
                type: 'error',
                message: '姓名和电话不能为空'
              })
              return
            }
            res = await axios.post('/admin/staff/add', params)
          }
        } catch (e) {

        }
        if (res) {
          func.personneGet()
          formData.innerVisible = false
          formData.curData2 = {}
        }
        console.log('保存人员', res)
      },
      async personnelDelete(Id) {
        ElMessageBox.confirm(t('g.sure_delete'), {
          confirmButtonText: t('confirm'),
          cancelButtonText: t('cancel'),
        }).then(() => {
          try {
            axios.post('/admin/staff/del', {
              Id
            }).then((res) => {
              if (res) {
                func.personneGet()
                ElMessage({
                  type: 'success',
                  message: t('g.success')
                })
              } else {
                ElMessage({
                  type: 'error',
                  message: t("err_code.20005")
                })
              }
              // func.loadData()
            })

          } catch (error) {
            ElMessage({
              type: 'error',
              message: t("err_code.20005")
            })
          }

        })
      },
      async delete(Id) {
        ElMessageBox.confirm(t('g.sure_delete'), {
          confirmButtonText: t('confirm'),
          cancelButtonText: t('cancel'),
        }).then(() => {
          try {
            axios.post('/admin/pilesite/delete', {
              Id
            }).then((res) => {
              if (res == '删除成功') {
                ElMessage({
                  type: 'success',
                  message: t('g.success')
                })
              } else {
                ElMessage({
                  type: 'error',
                  message: t("err_code.20005")
                })
              }
              func.loadData()
            })

          } catch (error) {
            ElMessage({
              type: 'error',
              message: t("err_code.20005")
            })
          }

        })
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      pageChange2(val) {
        console.log('page change', val)
        func.personneGet(val)
      },
      showAddDataDialog() {
        formData.curData = {
          Name: '',
          Address: '',
          ParkInfo: '',
        }
        formData.form_type = 'add'
        formData.activeName = 'first'
        formData.saveText = '下一步'
        formData.dialogVisible = true
      },
      async updateData() {
        if (!formData.curData.Name || formData.curData.Name == '') {
          ElMessage({
            type: 'error',
            message: '场站名称'
          })
          return
        }
        if (!formData.curData.CodePath) {
          ElMessage({
            type: 'error',
            message: '运营商不能为空'
          })
          return
        }
        if (formData.form_type == 'edit') {
          let arr = []
          for (let i = 0; i < formData.tablePersonne.length; i++) {

            if (!arr.includes(formData.tablePersonne[i].Role)) {
              arr.push(formData.tablePersonne[i].Role)
            }
          }
          if (arr.length < 4) {
            ElMessage({
              type: 'error',
              message: '请配置四种不同类型的接警人员'
            })
            return
          }
        }
        let res
        try {
          let params = Object.assign({}, formData.curData)
          params.DevType = 4
          if (formData.form_type == 'edit') {
            params.Id = formData.curData.Id
            await axios.post('/admin/pilesite/edit', params)
          } else {
            res = await axios.post('/admin/pilesite/add', params)
          }
        } catch (e) {

        }
        if (res && formData.form_type == 'add') {
          formData.tablePersonne = []
          formData.curData.Id = res.Id
          formData.form_type = 'edit'
          formData.activeName = 'second'
          formData.saveText = '保存'
        } else {
          formData.dialogVisible = false
          func.loadData()
        }
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page

          let params = {
            page,
          }
          if (formData.valOperator) {
            params.CodePath = formData.valOperator
          }
          params.DevType = 4
          let res = await axios.get(`/admin/pilesite/get`, {
            params
          })

          console.log('列表信息', res)
          formData.total = res.Total
          res.List.map((item) => {
            item.CreateAtStr = toDay(item.CreateAt)
          })
          formData.tableData = res.List
          formData.PageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }

    return {
      func,
      render,
      isOperator,
      isAdmin,
      formData,
      isPath,
      city,
      uploadUrl: cfg.uploadUrl,
      token: user.token,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;


        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;

    :deep(.el-form-item) {
      width: 33%;
    }

    .inp {
      width: 100%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  :deep(.m-dialog) {
    max-width: 50rem;
  }
}

.box_flex {
  display: flex;
}

.tabs {
  margin-bottom: 30px;
}

:deep .el-tabs--card>.el-tabs__header {
  border-top: 0px solid #e4e7ed !important;
}

:deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: 1px solid #e4e7ed !important;
}

:deep .el-tabs--card>.el-tabs__header {
  background-color: #fff !important;
}


.form-row {
  text-align: left;
  // padding: 0 60px;
  margin-top: 45px;

  .inp {
    width: 500px;
  }

  .inp_right {
    margin-right: 15px;
  }

  .label_box {
    display: flex;
    margin-bottom: 15px
  }

  .title_label {
    width: 100px;
    text-align: right;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }

  .money_box {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .time_money {
    margin-top: 30px
  }
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

:deep .avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep .avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

:deep .el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

.personnel_btn {
  text-align: right;
  margin-top: 15px;
}

.reminder {
  text-align: left;
  color: red;
  margin-bottom: 15px;
  font-weight: bold;
}
</style>
<!-- 

-->